import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('./Accent.module.less');
const cx = classnames.bind(styles) as any;

export enum Color
{
    Orange  = 'orange',
    Blue    = 'blue'
}

export enum Kind
{
    Color    = 'color',
    Underline = 'underline',
    ColorAndUnderline = 'colorAndUnderline'
}

export enum LayoutAs
{
    Inline  = 'inline',
    Block   = 'block'
}

interface Props
{
    kind?:Kind;
    color?:Color;
    layoutAs?:LayoutAs;
    className?:string;
}

class State
{
}

export default class Accent extends React.Component<Props, State>
{
    constructor(props: Props)
    {
        super(props);
    }

    render()
    {
        const {
                children,
                className,
                color=Color.Orange,
                kind=Kind.Underline,
                layoutAs=LayoutAs.Inline

        } = this.props;

        return  <div className={cx(className, 'accent', kind, color, layoutAs)}>
                    {children}
                </div>;
    }
}